<template>
  <div class="main" id="main">
    <my-header class="head"></my-header>
    <div class="profile-header">
      <div class="container">
        <div class="infos">
          <div class="avatar">
            <div class="image-container" style="width: 100px">
              <div class="image-container__image"></div>
              <div style="padding-top: 100%"></div>
            </div>
          </div>
          <div class="meta">
            <div class="name">
              <div class="user-name">
                <a href="#" class="user-name__link" title="bubblezww">{{
                  username
                }}</a>
              </div>
            </div>
            <div class="actions"></div>
            <div class="stats">
              <a class="follower-count" href="#" title="">
                <span class="count">0</span> 粉丝
              </a>
              <a class="following-count" href="#" title="">
                <span class="count">0</span> 关注
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="profile-tabs">
      <div class="container">
        <div class="sidebar horizontal">
          <ul class="sidebar__desktop">
            <li :class="{ item: true, active: tab == 2 }">
              <div class="link" @click="changeTab(2)">
                <span class="count">{{ total2 }}</span> 模型
              </div>
            </li>
            <li :class="{ item: true, active: tab == 1 }">
              <div class="link" @click="changeTab(1)">
                <span class="count">{{ total }}</span> 场景
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="list-container" id="list-loading">
      <div class="li" v-for="item in list" :key="item.id">
        <div class="li-title">{{ tab == 1 ? item.name : item.modelName }}</div>
        <div class="li-func">
          <el-button-group>
            <el-button
              type="success"
              size="small"
              icon="el-icon-edit"
              plain
              @click="openUpload(item)"
              >基础信息</el-button
            >
            <el-button
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              @click="openEdit(item)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="tab == 1"
              @click="deleteScenes(item.id)"
              >删除</el-button
            >
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-else
              @click="deleteModels(item.id)"
              >删除</el-button
            >
          </el-button-group>
        </div>
      </div>
    </div>
    <div class="block" v-if="sum != 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 500]"
        :page-size="currentSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="sum"
      >
      </el-pagination>
    </div>

    <my-upload v-if="show" :res="data" :type="type"></my-upload>
  </div>
</template>
<style>
.el-pagination {
  margin-bottom: 30px;
  text-align: center;
}
</style>
<style scoped>
.main {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  background: #f2f2f2;
  /* color: white; */
}

.upload-demo {
  margin: 300px;
}
.head {
  background: black;
}

.profile-header {
  height: 100px;
  display: flex;
  margin-top: 60px;
  padding: 30px 0;
  background: #000 url(../../public/imgs/common/polygons-gradients.png);
}
.container {
  width: 80%;
  max-width: 2000px;
  margin: 0 auto;
}
.profile-header .infos {
  display: flex;
  color: #fff;
  text-shadow: rgb(0 0 0 / 50%) 1px 1px 0;
  flex: auto;
}

.profile-header .infos .avatar {
  max-width: 100px;
  margin-right: 20px;
  flex: 1;
}

.profile-header .infos .avatar .image-container {
  width: 100px;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 30%);
  overflow: hidden;
}
.image-container__image {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-position: 50%;
  background-size: cover;
  background-image: url(../../public/imgs/common/user.jpg);
  opacity: 1;
  transition: opacity 0.25s ease;
}
.meta {
  flex: 1;
}
.meta .name {
  height: 40px;
  display: inline-block;
  float: left;
  font-size: 26px;
  font-weight: 300;
}
.user-name {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
}
.user-name__link {
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex: 1;
}
a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
.meta .actions {
  float: left;
  clear: both;
  display: flex;
}
.meta .stats {
  float: left;
  /* margin-left: 20px; */
  font-size: 14px;
  line-height: 24px;
}
.stats .follower-count,
.stats .follower-count {
  margin-right: 20px;
}
.item {
  position: relative;
  display: inline-block;
  margin-top: 0;
  margin-right: 5px;
}
.profile-tabs .sidebar {
  width: auto;
  margin: 20px 0 30px;
}
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.sidebar .link {
  display: block;
  padding: 8px 14px;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  line-height: 20px;
  color: #555 !important;
  text-transform: uppercase;
  border-radius: 16px;
  letter-spacing: 2px;
  cursor: pointer;
}
.sidebar .item.active .link {
  font-weight: 600;
  color: #fff !important;
  background: #1caad9;
}
.sidebar .link:hover {
  background: #dbdbdb;
}
.list-container {
  min-height: 500px;
}
.li {
  height: 60px;
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto 15px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: white;
}
.li-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.li-func {
  margin-left: 20px;
}
</style>
<script>
import https from "@/https.js";
import MyHeader from "@/components/header.vue";
import MyUpload from "@/components/upload2.vue";
import { Loading } from "element-ui";
export default {
  components: {
    MyHeader: MyHeader,
    MyUpload: MyUpload,
  },
  data() {
    return {
      username: null,
      tab: 2,
      list: [],
      currentSize: 10,
      currentPage: 1,
      total: 0,
      total2: 0,
      sum: 0,

      show: false,
      data: {},
      type: "1",
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.username = window.sessionStorage.getItem("model_username");
      this.init2();
      https
        .fetchGet("/GetBaseSceneInfoPage", {
          pageIndex: this.currentPage,
          pageSize: this.currentSize,
          projectName: "",
        })
        .then((res) => {
          console.log(res.data);
          this.total = res.data.count;
        });
    },
    init1() {
      let loadingInstance = Loading.service({
        target: document.querySelector("#list-loading"),
        fullscreen: false,
        body: false,
      });
      https
        .fetchGet("/GetBaseSceneInfoPage", {
          pageIndex: this.currentPage,
          pageSize: this.currentSize,
          projectName: "",
        })
        .then((res) => {
          console.log(res.data);
          this.total = res.data.count;
          this.sum = res.data.count;
          this.list = res.data.result;
          loadingInstance.close();
        });
    },
    init2() {
      let loadingInstance = Loading.service({
        target: document.querySelector("#list-loading"),
        fullscreen: false,
        body: false,
      });
      https
        .fetchGet("/GetModels", {
          pageIndex: this.currentPage,
          pageSize: this.currentSize,
        })
        .then((res) => {
          console.log(res.data);
          this.total2 = res.data.count;
          this.sum = res.data.count;
          this.list = res.data.result;
          loadingInstance.close();
        });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentSize = val
      if (this.tab == 1) {
        this.init1();
      }
      if (this.tab == 2) {
        this.init2();
      }
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.currentPage = val
      if (this.tab == 1) {
        this.init1();
      }
      if (this.tab == 2) {
        this.init2();
      }
      console.log(`当前页: ${val}`);
    },
    changeTab(num) {
      if (this.tab != num) {
        this.tab = num;
        this.currentPage = 1;
        if (num == 1) {
          this.init1();
        }
        if (num == 2) {
          this.init2();
        }
      }
    },
    openEdit(item) {
      if (this.tab == "2") {
        this.$router.push({ path: "/modelEdit?id=" + item.id });
      } else if (this.tab == "1") {
        this.$router.push({ path: "/sceneEdit?id=" + item.id });
      } else {
        this.data = item;
        this.show = true;
      }
    },
    close() {
      this.show = false;
    },
    saveClose() {
      this.show = false;
      if (this.tab == "1") {
        this.init1();
      } else {
        this.init2();
      }
    },
    openUpload(item) {
      if (this.tab == "1") {
        this.type = "2";
      } else {
        this.type = "1";
      }
      console.log(item);
      this.data = item;
      if(!this.data.type){
        this.data.type = item.sceneType
      }
      this.show = true;
    },
    deleteScenes(id) {
      this.$confirm("确定删除该模型吗？", "确认信息", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        https
          .fetchGet("/DeleteScene", {
            id: id,
          })
          .then((res) => {
            console.log(res.data);
            this.currentPage = 1;
            this.init1();
            this.$message({
              type: "success",
              message: "删除成功",
            });
          });
      });
    },
    deleteModels(id) {
      this.$confirm("确定删除该上传文件吗？", "确认信息", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        https
          .fetchGet("/DeleteModel", {
            id: id,
          })
          .then((res) => {
            console.log(res.data);
            this.currentPage = 1;
            this.init2();
            this.$message({
              type: "success",
              message: "删除成功",
            });
          });
      });
    },
  },
};
</script>
